export default __webpack_public_path__ + "static/media/12.f7c9b07b.jpg";